export default function CustForm() {
    return(
        <div className="col-12">
            <div className="overflow-auto card recent-sales">
                <div className="card-body">
                    <h5 className="card-title"><span>------------</span></h5>
                </div>
            </div>
        </div>
    )
}